import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DRIVERS_DATA, FETCH_DRIVERS_DETAILS_DATA } from "./actionTypes";
import {
  fetchDriversSuccess,
  fetchDriversFailure,
  fetchDriversDetailsSuccess,
  fetchDriversDetailsFailure
} from "./actions";

function* fetchDriversDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/drivers",{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    yield put(fetchDriversSuccess(response.data));
  } catch (error) {
    yield put(fetchDriversFailure(error.message));
  }
}

function* fetchDriversDetailsDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/drivers/${id}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    yield put(fetchDriversDetailsSuccess(response.data));
  } catch (error) {
    yield put(fetchDriversDetailsFailure({
      message: error?.response?.data?.message || error.message,
      status: error?.response?.status
    }));
  }
}

export default function* driversSaga() {
  yield takeEvery(FETCH_DRIVERS_DATA, fetchDriversDataSaga);
  yield takeEvery(FETCH_DRIVERS_DETAILS_DATA, fetchDriversDetailsDataSaga); 
}
